import React from 'react';
import './Offices.css';
import GalleryTemplate from "../gallery template/GalleryTemplate";

class Offices extends React.Component {

    componentDidMount() {
    }

    render() {
        return (
            <div className={'page'}>
                <div className={'offices'}>
                    <h1 className={'pageTitle'}>Bespoke Home Office & Study Furniture</h1>
                    <p className={'pageDescription'}>Create the perfect environment to focus and thrive with our custom-built home office furniture. We design and craft bespoke desks, integrated shelving, and complete study storage solutions tailored to your unique workspace needs. Whether you are looking to transform a spare room or maximize a smaller nook, our professional joinery ensures your home office is both highly functional and beautifully finished.</p>
                    <GalleryTemplate
                        title={'Floating Desk and Shelving'}
                        description={'Durable and aesthetically pleasing, this custom-built wooden desk and matching floating shelves with sturdy metal brackets provide a functional and stylish workspace or display area.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/Bookcases/6/IMG-20210103-WA0003.JPG'
                        ]}/>
                    <GalleryTemplate
                        title={'Custom Home Office Desk and Shelving Unit'}
                        description={'Create your ideal work-from-home environment with this bespoke dark blue office unit, combining a spacious solid wood desk with integrated shelving for efficient organisation and a professional look.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/Bookcases/6/IMG-20250520-WA00051.JPG'
                        ]}/>
                    <GalleryTemplate
                        title={'Bespoke Home Office & Study Workspace'}
                        description={'Create a productive and stylish work-from-home environment with our custom-built office joinery. This setup features a sleek, integrated desk area combined with extensive shelving and storage, designed to keep your workspace organised and professional.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/Offices/1/IMG-20260519-WA0003.JPG',
                            '/gallery/Offices/1/IMG-20260519-WA0002.JPG'
                        ]}/>
                </div>
            </div>
        );
    }
}

export default Offices;
